var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCodeCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 4.5,
    stroke: "#B5B5B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8398_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 14.2795C11.1667 13.4542 11.4946 12.6628 12.0781 12.0793C12.6616 11.4958 13.453 11.168 14.2782 11.168H24.3886C24.7972 11.168 25.2018 11.2485 25.5793 11.4048C25.9568 11.5612 26.2998 11.7904 26.5887 12.0793C26.8777 12.3682 27.1069 12.7112 27.2632 13.0887C27.4196 13.4663 27.5001 13.8709 27.5001 14.2795V24.3898C27.5001 24.7984 27.4196 25.203 27.2632 25.5805C27.1069 25.958 26.8777 26.301 26.5887 26.59C26.2998 26.8789 25.9568 27.1081 25.5793 27.2645C25.2018 27.4208 24.7972 27.5013 24.3886 27.5013H14.2782C13.8696 27.5013 13.465 27.4208 13.0875 27.2645C12.71 27.1081 12.367 26.8789 12.0781 26.59C11.7892 26.301 11.56 25.958 11.4036 25.5805C11.2472 25.203 11.1667 24.7984 11.1667 24.3898V14.2795Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68067 22.5265C7.3229 22.3225 7.02532 22.0277 6.818 21.6719C6.61069 21.3161 6.50099 20.9118 6.5 20.5V8.83333C6.5 7.55 7.55 6.5 8.83333 6.5H20.5C21.375 6.5 21.851 6.94917 22.25 7.66667",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8398_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCodeCopy);
export default __webpack_public_path__ + "static/media/ic-code-copy.482cf53de0b830607570dfa246cf8c79.svg";
export { ForwardRef as ReactComponent };